import { createSelector } from 'reselect';
import { entitiesSelector } from '../common/state/selectors/issue-selector.tsx';

const jpdIdeasLinksSelector = createSelector(entitiesSelector, (entities) => entities.jpdIdeas);

export const showLinkIdeasInputSelector = createSelector(
	jpdIdeasLinksSelector,
	(jpdIdeas) => jpdIdeas?.showLinkIdeaInput || false,
);
